/* eslint-disable no-console */
import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  ViewEncapsulation
} from '@angular/core';
import { isEmpty, cloneDeep, round } from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as Highcharts from 'highcharts';
import Highcharts3D from 'highcharts/highcharts-3d';
Highcharts3D(Highcharts);
import { CollectorApiService, ControllerApiService } from '@nrwl/test-setup';
import {
  HelpersService,
  LmapService,
  LicensesPageService,
  DevicesService,
  WindowWalkService,
  AGENT_MODEL,
  TestMode,
  TestModeLabel
} from '@nrwl/common-lib';
import { ReportsTransformationService } from '../../../services/reports.transformation.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'nrwl-udp-final',
  templateUrl: './udp-final.component.html',
  styleUrls: ['./udp-final.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UdpFinalComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @ViewChild('pdfPage') element: ElementRef;
  @Input() expertView: boolean;
  @Input() reportName: string;
  @Input() chartId: string;
  @Input() reportStartTime: string;
  @Input() scheduleId: number;
  @Input() runId: number;
  @Input() testName: string;
  @Input() public = false;
  reportTitle = 'UDP Test Report';
  loading: boolean;
  runSaturationWindow = false;
  dynamicSaturationWindow = false;
  testConfigsDataSource;
  dataSource: BehaviorSubject<any>;
  testType: string;
  requestInfo = {};
  rptTimeOutMs = 20;
  rptMaxRequestRetries = 3;
  charts = {};
  streamNum = 0;
  rptLastSampleDate = null;
  finalResultAvailable = false;
  displayOverallResult = false;
  resultsNotAvailable = true;
  overallResult = null;
  errorMessage = '';
  Highcharts: typeof Highcharts = Highcharts;
  firstRetrieveDone = false;
  rptTotalTime = 0;
  testConfig = null;
  testMode = null;
  streamRateConventionL1 = 'L1 ULR';
  streamRateConventionL2 = 'L2 IR';
  rptRequestRetries = 0;
  streamRateConvention = this.streamRateConventionL2;
  startDate = null;
  rptBatchSize = 1000;
  stopDate = null;
  duration = '--';
  controllerStatus = '';
  originators = ['engine-a', 'engine-b'];
  rptSamplesNeeded = 0;
  rptSamplesReceived = 0;
  rptRequestCtr = 0;

  pageHeight: string;
  clientHeight: number;
  resultType: string;
  upstreamOn: boolean;
  downstreamOn: boolean;
  hasClientInfo: boolean;
  sptConfiguration = {};
  rptStartRequestTime = null;
  upstreamSummary = {};
  downstreamSummary = {};
  testSummary = {};

  clientInfo = {};
  rtRequestCtr: number;
  rtTotalTime: number;
  windowResults = [];
  windowSummary = [];
  dataSourceItem = [];
  finishStatus: string;
  displayTrendingChartObject = {};
  startRTRequestTime: Date;
  upstreamWindowResult;
  downstreamWindowResult;
  aggregateDataRptKey = 'Aggregate';
  streams = [];
  olderConfigVersion = false;
  testConfigDisplay: any = {
    overall: [],
    streams: [],
    destination: [],
    tpaVersion: null,
    tpbVersion: null
  };
  aggregatedData = {
    'engine-a-to-engine-b': { bw: 0, ulrOrIr: 0, ulrOrIr2: 0, count: 0 },
    'engine-b-to-engine-a': { bw: 0, ulrOrIr: 0, ulrOrIr2: 0, count: 0 }
  };
  streamMode: string;
  trendingInProgress = false;
  trendingComplete = false;
  rptSampleEndTime: any;
  trendingMsg = '';
  trendingResults = [];
  trendingPercent = 0;
  showRtdOptions = false;
  formattedDate: any;
  pluginConfig = false;
  private readonly unsubscribe: Subject<void> = new Subject();
  overallConfiguration: any;
  uiConfig: any;
  dataTypes: string[] = ['Throughput', 'Packet Loss Ratio', 'Round Trip Time', 'Jitter'];
  pcClientDataTypes: string[] = ['Throughput', 'Round Trip Time'];
  selectedDataType: string[] = ['Throughput'];
  isPcClientView = false;
  displayedColumns: string[] = ['header', 'value'];
  clientCpuUsage = [];
  clientMemoryUsage = [];
  uiStreams = [];
  rptSeqNumsProcessed = [];
  layer: string;
  unknownText: any;
  rtnValue: string;
  bidirsequentialData: any;
  bidirsequentialUlrOrIrbw: number;
  bidirsequentialUlrOrIrbw2: number;
  finalReport: any;
  finalAngReport: any;
  successText = 'Pass';
  failText = 'Fail';
  myError: string;
  logoUrl = 'images/viavi-logo-purple.png';
  chartValid = false;
  reportArray = [];
  filterChart: any;
  trendChartData: void;
  onchanges = false;
  hasAggregate = false;
  clientInfoDataSource: any;
  clientToMa = false;
  serverConfig: any;
  reportmessage: any;
  finalReports = [];
  shaId: any;
  configuration = {};
  selectedOriginator: any;
  activeLicense: string;
  licenseDetails: any = [];
  constructor(
    private collectorApiService: CollectorApiService,
    private controllerApiService: ControllerApiService,
    private readonly helperService: HelpersService,
    private licenseService: LicensesPageService,
    readonly deviceService: DevicesService,
    private lmapService: LmapService,
    private transformService: ReportsTransformationService,
    private cdr: ChangeDetectorRef,
    private windowWalkService: WindowWalkService
  ) {
    this.loading = false;
    this.expertView = false;
    this.hasClientInfo = false;
  }

  ngOnInit(): void {
    this.isPcClientView = this.public;
    this.init();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.expertView) {
      this.expertView = changes.expertView.currentValue;
    }
    if (
      changes &&
      ((changes.runId && !changes.runId.firstChange) ||
        (changes.reportStartTime && !changes.reportStartTime.firstChange))
    ) {
      this.onchanges = true;
      this.firstRetrieveDone = false;
      this.trendingInProgress = false;
      this.uiStreams = [];
      this.testConfigDisplay = {
        overall: [],
        streams: [],
        destination: [],
        tpaVersion: null,
        tpbVersion: null
      };
      this.reportArray = [];
      this.trendingResults = [];
      this.rptSeqNumsProcessed = [];
      this.charts = {};
      this.init();
    }
  }

  init(): void {
    this.loading = true;
    if (!this.isPcClientView) {
      this.getLicenseDetails();
      this.getServerConfig();
    }
    this.getTestConfig();
  }

  getServerConfig(): void {
    this.controllerApiService.getServerConfig().subscribe(response => {
      this.serverConfig = response.data;
      const serverConfig = response.data['reports'];
      if (serverConfig && serverConfig.logo && serverConfig.logo.url) {
        this.logoUrl = serverConfig.logo.url;
      }
      if (serverConfig && serverConfig.message) {
        this.reportmessage = serverConfig.message;
      }
    });
  }

  getTestConfig(): void {
    this.controllerApiService
      .getTestConfig(this.scheduleId, this.isPcClientView)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        if (response.status === 'success') {
          this.overallConfiguration = response.data.config;
          this.shaId = response.data?.sha ? response.data.sha : null;
          if (!this.overallConfiguration.agent.secondary) {
            this.testMode = TestModeLabel.CLIENT_TO_MA;
            this.clientToMa = true;
          } else {
            this.testMode = TestModeLabel.MA_TO_MA;
            this.clientToMa = false;
          }
          this.processReport();
          this.getRTResults();
        }
      });
  }
  getRTResults(): void {
    this.rtRequestCtr++;
    this.startRTRequestTime = new Date();
    this.collectorApiService
      .getQueryReportByFromTime(
        this.scheduleId,
        this.runId,
        'rt',
        this.reportStartTime,
        this.rptBatchSize,
        null,
        this.isPcClientView
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => {
        if (res.status === 'success') {
          const getRTResultResponse = res.data;
          // this.processRTResults(getRTResultResponse);
          this.calculateTotalStat();
        }
      });
  }

  testConfigDisplayData(): void {
    let streams = [];
    if (this.overallConfiguration) {
      const config = this.lmapService.getTestOptions('udp', ['udp'], this.overallConfiguration);
      if (config && config.udp) {
        this.testConfig = JSON.parse(config.udp);
        streams = this.testConfig?.['udp:udp']?.['streams'];
      }
    }
    if (this.overallConfiguration && this.overallConfiguration.test) {
      if (this.overallConfiguration.test['extended-config']) {
        this.uiConfig = this.overallConfiguration.test['extended-config'];

        // build a list of UI configured streams that can be used to build a better
        // report - only include the enabled ones so the stream numbers align with the MA's report
        if (
          this.uiConfig &&
          this.uiConfig.pluginConfig &&
          this.uiConfig.pluginConfig.connections &&
          this.uiConfig.pluginConfig.connections.connections[0] &&
          this.uiConfig.pluginConfig.connections.connections[0].streams
        ) {
          this.pluginConfig = true;
          const cstreams = this.uiConfig.pluginConfig.connections.connections[0].streams;
          for (let stIdx = 0, stLen = cstreams.length; stIdx < stLen; ++stIdx) {
            // if (cstreams[stIdx].strmInUse === 'true') {
            this.uiStreams.push(cstreams[stIdx]);
            // }
          }
        }
        if (
          this.uiConfig &&
          this.uiConfig.testPoints &&
          this.uiConfig.testPoints.length &&
          this.uiConfig.testPoints.length > 0
        ) {
          for (let x = 0; x < this.uiConfig.testPoints.length; x++) {
            if (this.uiConfig.testPoints[x].name === this.overallConfiguration.agent.primary.id) {
              if (this.uiConfig.testPoints[x].version) {
                this.testConfigDisplay.tpaVersion = this.uiConfig.testPoints[x].version;
              }
            } else if (
              this.overallConfiguration.agent.secondary &&
              this.overallConfiguration.agent.secondary.length &&
              this.overallConfiguration.agent.secondary.length > 0 &&
              this.uiConfig.testPoints[x].name === this.overallConfiguration.agent.secondary[0].id
            ) {
              this.testConfigDisplay.tpbVersion = this.uiConfig.testPoints[x].version;
            }
          }
        }
      } else {
        if (streams.length > 0) {
          for (let stIdx = 0, stLen = streams.length; stIdx < stLen; ++stIdx) {
            // if (cstreams[stIdx].strmInUse === 'true') {
            this.uiStreams.push(streams[stIdx]);
            // }
          }
        }
      }

      this.layer = 'Layer 4';
    } else {
      if (streams.length > 0) {
        for (let stIdx = 0, stLen = streams.length; stIdx < stLen; ++stIdx) {
          // if (cstreams[stIdx].strmInUse === 'true') {
          this.uiStreams.push(streams[stIdx]);
          // }
        }
      }
      if (this.overallConfiguration?.agent?.primary?.id) {
        const deviceId = this.overallConfiguration?.agent?.primary?.id;
        const device = this.deviceService.findDeviceByUniqueName(deviceId);
        this.testConfigDisplay.tpaVersion = device?.['deviceData']?.['model']?.['version'];
      }
      if (this.overallConfiguration?.agent?.secondary) {
        const deviceId = this.overallConfiguration?.agent?.secondary?.[0]?.id;
        const device = this.deviceService.findDeviceByUniqueName(deviceId);
        this.testConfigDisplay.tpbVersion = device?.['deviceData']?.['model']?.['version'];
      }
    }
  }
  calculateTotalStat(): void {
    for (let windowCount = 0; windowCount < this.windowResults.length; windowCount++) {
      const windowResult = this.windowResults[windowCount];
      let totalTranmit = 0;
      let totalRetransmit = 0;
      for (let j = 0; j < windowResult.transmitted.length; j++) {
        totalTranmit += windowResult.transmitted[j];
        totalRetransmit += windowResult.retransmitted[j];
      }

      for (let k = 0; k < this.windowSummary.length; k++) {
        if (this.windowSummary[k]['window-id'] === windowResult.id) {
          this.windowSummary[k]['total-transmit'] = totalTranmit;
          this.windowSummary[k]['total-retransmit'] = totalRetransmit;
        }
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  createRequestInfo(data: any): any {
    const requestInfo = {};
    if (data && data.test && data.test['extended-config']) {
      requestInfo['techInfo'] = data.test['extended-config'].technicianInfo;
      requestInfo['testName'] = data.test['extended-config'].testInfo.name;
      requestInfo['mode'] = data.test['extended-config'].test.mode.toUpperCase();
      requestInfo['comments'] = data.test['extended-config'].testInfo.comments;
    } else {
      requestInfo['mode'] = this.testMode?.toUpperCase();
      requestInfo['testName'] =
        this.overallConfiguration?.['config']?.[0]?.['primaryConfig']?.['ietf-lmap-control:lmap']?.[
          'schedules'
        ]?.['schedule']?.[0]?.name;
    }

    if (data && data.test && data.test['test-list-data']) {
      requestInfo['customerInfo'] = data.test['test-list-data'].customer;
      requestInfo['mode'] = data.test['test-list-data'].mode.toUpperCase();
    }
    const primaryUrl = this.helperService.createPublicAccessURL(this.serverConfig, this.shaId);
    const secondaryUrl = this.helperService.generateSecondaryTestUDPURL(
      this.serverConfig,
      this.shaId,
      this.selectedOriginator
    );
    requestInfo['expirationDate'] = this.helperService.getReportDateTimeString(
      data?.test?.controller?.['expiration-date']
    );
    requestInfo['dmzUrl'] = primaryUrl ? primaryUrl + '&type=' + this.activeLicense : '';
    requestInfo['vtaTsUrl'] = secondaryUrl ? secondaryUrl + '&type=' + this.activeLicense : '';
    let agentName = data && data && data.agent && data.agent.primary ? data.agent.primary.id : null;
    if (!agentName) {
      agentName =
        data &&
        data &&
        data.test &&
        data.test['extended-config'] &&
        data.test['extended-config'].testPoints &&
        data.test['extended-config'].testPoints > 0
          ? data.test['extended-config'].testPoints[0].name
          : null;
    }
    return requestInfo;
  }

  getLicenseDetails(): void {
    this.licenseService
      .getLicenseCount()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        this.licenseDetails = response;
        this.setActiveLicense();
      });
  }

  setActiveLicense(): void {
    let thinClientobj = null;
    let fatClientobj = null;
    const isQtDevice =
      this.selectedOriginator?.deviceData?.model.model.indexOf('QT') !== -1 ||
      this.selectedOriginator?.deviceData?.model.model.indexOf('NSC') !== -1 ||
      this.selectedOriginator?.deviceData?.model.model.indexOf('MAP-2100') !== -1;
    if (this.licenseDetails?.length > 0) {
      thinClientobj = this.licenseDetails.find(o => o.featureName === 'EAX-UDP-PC-TC');
      fatClientobj = this.licenseDetails.find(o => o.featureName === 'EAX-UDP-PC-CLIENT');
      if (thinClientobj && fatClientobj && !isQtDevice) {
        this.activeLicense = 'tf';
      } else if (thinClientobj && !isQtDevice) {
        this.activeLicense = 'thin-engine';
      } else if (fatClientobj) {
        this.activeLicense = 'fat-engine';
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  processClientInfo(response: any): any {
    let interfaceInfo = false;
    let systemInfo = false;
    let processInfo = false;
    const reports = response.data;

    let lastCpuUsageSequence = 0;
    let lastCpuUsageReport = [];

    for (let i = 0; i < reports.length; i++) {
      if (reports[i]['ietf-lmap-report:report'] && reports[i]['ietf-lmap-report:report'].result) {
        const result = reports[i]['ietf-lmap-report:report'].result[0];
        if (result.tag && result.tag.length > 0) {
          const values = result.table[0].row;
          let sequence = null;
          let tableType = null;
          let foundSeq = false;
          let foundType = false;
          for (let x = 0, len = result.tag.length; x < len; ++x) {
            if (result.tag[x].indexOf('sequence:') >= 0) {
              sequence = parseInt(result.tag[x].split(':')[1]);
              foundSeq = true;
            }
            if (result.tag[x].indexOf('table-type:') >= 0) {
              tableType = result.tag[x];
              foundType = true;
            }

            if (foundSeq && foundType) {
              break;
            }
          }

          //interface info
          if (tableType && tableType.indexOf('interfaces') !== -1 && !interfaceInfo) {
            this.hasClientInfo = true;
            interfaceInfo = true;
            this.clientInfo['interfaces'] = [];

            for (let j = 0; j < values.length; j++) {
              const d = {};
              d['name'] = values[j].value[0];
              d['ip'] = values[j].value[1];
              d['transmitBuffer'] = values[j].value[2] ? values[j].value[2] : null;
              d['receiveBuffer'] = values[j].value[3] ? values[j].value[3] : null;
              this.clientInfo['interfaces'].push(d);
            }
          }

          //system info
          if (tableType && tableType.indexOf('system-info') !== -1 && !systemInfo) {
            this.hasClientInfo = true;
            systemInfo = true;
            this.clientInfo['systemInfo'] = {};
            this.clientInfo['systemInfo'].engBPublicIPAddr = this.testSummary['engBPublicIPAddr'];
            this.clientInfo['systemInfo'].engBPrivateIPAddr = this.testSummary['engBPrivateIPAddr'];
            this.clientInfo['systemInfo'].cpuNumber = values[0].value[0];
            this.clientInfo['systemInfo'].cpuModel = values[0].value[1];
            this.clientInfo['systemInfo'].cpuVendor = values[0].value[2];
            this.clientInfo['systemInfo'].osVersion = values[0].value[3];
            this.clientInfo['systemInfo'].memory = values[0].value[7];
          }

          //processes
          if (tableType && tableType.indexOf('processes') !== -1 && !processInfo) {
            this.hasClientInfo = true;
            processInfo = true;
            this.clientInfo['processes'] = {};
            for (let j = 0; j < values.length; j++) {
              const name = values[j].value[0];
              if (this.clientInfo['processes'][name]) {
                this.clientInfo['processes'][name] += 1;
              } else {
                this.clientInfo['processes'][name] = 1;
              }
            }
          }
          //cpu usage
          if (tableType && tableType.indexOf('cpu-usage') !== -1) {
            this.hasClientInfo = true;

            if (sequence && lastCpuUsageSequence < sequence) {
              lastCpuUsageSequence = sequence;
              lastCpuUsageReport = values;
            }
          }
        }
      }
    }

    if (this.hasClientInfo) {
      let maxCpuUsage = 0;
      for (let i = 0; i < lastCpuUsageReport.length; i++) {
        this.clientCpuUsage.push(parseFloat(lastCpuUsageReport[i].value[0]) * 100);
        const usedMemory = this.clientInfo['systemInfo'].memory - lastCpuUsageReport[i].value[1];
        const usedPercet = (usedMemory / this.clientInfo['systemInfo'].memory) * 100;
        this.clientMemoryUsage.push(usedPercet);
        if (parseFloat(lastCpuUsageReport[i].value[0]) > maxCpuUsage) {
          maxCpuUsage = parseFloat(lastCpuUsageReport[i].value[0]);
        }
      }
      this.clientInfo['systemInfo'].maxCpuUsage = (maxCpuUsage * 100).toFixed(2);
    }
    if (this.hasClientInfo) {
      const clientInfoConfiguration = this.transformService.getClientConfiguration(
        this.clientInfo,
        this.testType
      );
      this.clientInfoDataSource = new MatTableDataSource(clientInfoConfiguration);
    }
  }

  transformData(data: any[]): any[] {
    return data.map(item => {
      if (item.originator === 'engine-b') {
        return {
          ...item,
          'stream-number': (parseInt(item['stream-number'], 10) + 10).toString()
        };
      }
      return item;
    });
  }

  //eslint-disable-next-line
  getFinalReportBasedOnStartDate(res: any): any {
    if (res && res.length > 0) {
      if (res[0]?.['ietf-lmap-report:report'] && res[0]?.['ietf-lmap-report:report']?.result) {
        const startDate = res[0]['ietf-lmap-report:report'].result[0].start;
        return res.filter(item => item['ietf-lmap-report:report'].result[0].start === startDate);
      }
    }
    return res;
  }

  processReport(): void {
    this.collectorApiService
      .getQueryReportByFromTime(
        this.scheduleId,
        this.runId,
        'final',
        this.reportStartTime,
        1000,
        null,
        this.isPcClientView
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          if (response.status === 'success') {
            if (response && response.data && response.data.length) {
              this.finalReports = response.data.filter(report =>
                report['ietf-lmap-report:report'].result[0]?.tag.includes(
                  'table-type:final-results'
                )
              );

              this.finalReports = this.getFinalReportBasedOnStartDate(this.finalReports);

              //overriding test config with current testid config
              const currentRunConfig = this.getTestConfigOption(response.data);
              if (!isEmpty(currentRunConfig)) {
                this.overallConfiguration.config[0].primaryConfig[
                  'ietf-lmap-control:lmap'
                ].schedules.schedule[0].action[0].option = currentRunConfig;
              }
              this.testConfigDisplayData();

              if (this.overallConfiguration) {
                const config = this.lmapService.getTestOptions(
                  'udp',
                  ['udp'],
                  this.overallConfiguration
                );
                if (config && config.udp) {
                  this.testConfig = JSON.parse(config.udp);
                }
                this.configuration = this.windowWalkService.parseUDPConfiguration({
                  config: this.overallConfiguration
                });
                this.selectedOriginator = this.deviceService.findById(
                  this.configuration?.['engineA']?.address
                );
              } else {
                console.error(
                  'Cannot create configuration section - controller configuration is not present'
                );
              }

              if (this.testConfig) {
                if (response.data.length > 0 && response.data[0]['ietf-lmap-report:report']) {
                  const report = response.data[0]['ietf-lmap-report:report'];
                  this.testConfig['agent-id'] = report['agent-id'];
                  this.testConfig['date'] = new Date(report['date']).toDateString();
                }

                if (this.testConfigDisplay.overall.length === 0) {
                  this.createOverallTestSetup();
                }
                if (this.testConfigDisplay.streams.length === 0) {
                  this.createStreamsTestSetup();
                }

                for (const stream of this.testConfig['udp:udp'].streams) {
                  stream['finalResults'] = [];
                }

                if (this.finalReport && this.finalReport !== undefined) {
                  const isZeroBased = false;
                  if (
                    !Array.isArray(this.finalReport) ||
                    !this.finalReport.every(item => typeof item === 'object' && item !== null)
                  ) {
                    // If it's not an array or not an array of objects, convert it into an array of objects
                    this.finalReport = [{ value: this.finalReport }];
                  }

                  for (const result of this.finalReport) {
                    let snum = parseInt(result['stream-number'], 10);
                    if (!isZeroBased) snum -= 1;

                    const stream = this.testConfig['udp:udp'].streams[snum];
                    if (stream && stream.finalReports) {
                      stream.finalReports.push(result);
                    }
                  }
                }
              } else {
                console.error(
                  'Cannot create configuration section - test configuration is not present'
                );
              }

              // Set start/stop dates
              this.startDate = null;
              this.stopDate = null;

              if (this.finalReports.length) {
                for (const reportData of this.finalReports) {
                  const report = reportData['ietf-lmap-report:report'];
                  if (report) {
                    const myStopDate = new Date(report.date);
                    if (!this.stopDate || myStopDate.getTime() > this.stopDate.getTime()) {
                      this.stopDate = myStopDate;
                    }

                    if (!this.startDate && report.result?.length > 0) {
                      this.startDate = new Date(report.result[0].start);
                    }
                  }
                }
              }
              this.processStartStopDates();
              this.requestInfo = this.createRequestInfo(this.overallConfiguration);

              // Convert response for Angular
              let angularFinalResult = null;
              if (this.finalReports && typeof this.finalReports === 'object') {
                let idx = this.finalReports.length - 1;
                while (angularFinalResult == null && idx >= 0) {
                  const sequentialData =
                    this.streamMode === 'bidirsequential'
                      ? this.formatSequentialBiDirectional(this.finalReports)
                      : this.finalReports;
                  angularFinalResult =
                    this.lmapService.ltranslateLmapReportIndexToAngular(sequentialData);
                  idx--;
                }
              }

              const angularEngineBUpdate = this.transformData(angularFinalResult);
              angularFinalResult = angularEngineBUpdate;

              let finalReport = null;
              if (angularFinalResult) {
                finalReport = {};
                this.convertAngularReportToDisplay(angularFinalResult, finalReport);
              }

              this.finalReport = finalReport;
              this.finalAngReport = angularFinalResult;

              // this.processData(this.finalReport);

              const result = this.finalAngReport
                ? this.getVerdict(this.finalAngReport)
                : this.successText;
              this.overallResult = result;
              this.finalResultAvailable = !!this.finalAngReport;
              this.resultsNotAvailable = !this.finalResultAvailable;
              this.displayOverallResult = this.finalResultAvailable;

              if (this.overallResult === this.failText) {
                this.myError = this.produceErrorObj(this.finalAngReport);
              }
              if (this.myError) {
                this.errorMessage = this.myError;
              }
            }
            if (this.testMode === TestModeLabel.CLIENT_TO_MA) {
              let windowResults = null;
              const latestReport = this.windowWalkService.getLatestReport(this.finalReports);
              const configuration = this.windowWalkService.parseConfiguration({
                config: this.overallConfiguration
              });
              windowResults = this.windowWalkService.getWindowResults(latestReport, configuration);
              this.testSummary['engBPublicIPAddr'] = windowResults.engBPublicIPAddr;
              this.testSummary['engBPrivateIPAddr'] = windowResults.engBPrivateIPAddr;
              this.setActiveLicense();
              // this.requestInfo = this.createRequestInfo(this.overallConfiguration);
              this.processClientInfo(response);
            }
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  //eslint-disable-next-line
  getTestConfigOption(response): any {
    let optionValue = [];
    if (response.length) {
      const reports = response[0];
      const testOptions = reports['ietf-lmap-report:report'].result[0].option;
      optionValue = testOptions;
    }
    return optionValue;
  }

  private getVerdict(angularReport: any): string {
    let verdict = this.successText;

    for (const x of Object.keys(angularReport)) {
      for (const y of Object.keys(angularReport[x])) {
        if (typeof y === 'string' && y.includes('verdict')) {
          if (angularReport[x][y] === 'fail') {
            verdict = this.failText;
            break;
          }
        }
      }

      if (verdict === this.failText) {
        break;
      }
    }

    return verdict;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  formatSequentialBiDirectional(responseData: any): any {
    // Clone the response data to avoid mutating the original
    const data = cloneDeep(responseData);

    // Push the first row of the second data set into the first data set
    if (
      data.length > 1 &&
      data[0]['ietf-lmap-report:report'] &&
      data[0]['ietf-lmap-report:report']['result'] &&
      data[0]['ietf-lmap-report:report']['result'][0]['table'] &&
      data[0]['ietf-lmap-report:report']['result'][0]['table'][0]['row'] &&
      data[1]['ietf-lmap-report:report']['result'] &&
      data[1]['ietf-lmap-report:report']['result'][0]['table'] &&
      data[1]['ietf-lmap-report:report']['result'][0]['table'][0]['row']
    ) {
      data[0]['ietf-lmap-report:report']['result'][0]['table'][0]['row'] = [
        ...data[0]['ietf-lmap-report:report']['result'][0]['table'][0]['row'],
        ...data[1]['ietf-lmap-report:report']['result'][0]['table'][0]['row']
      ];
    }

    // Return the formatted data as an array with the modified first element
    const formattedData = [data[0]];
    return formattedData;
  }

  private produceErrorObj(finalReport: any[]): string | null {
    let errMsg = null;
    let packetLossErrorCount = 0;
    let jitterErrorCount = 0;
    let firstFailedStreamNum = null;
    let multipleStreamsFailed = false;

    for (const report of finalReport) {
      if (report['verdict'] === 'fail') {
        if (firstFailedStreamNum === null) {
          firstFailedStreamNum = report['stream-number'];
        } else if (firstFailedStreamNum !== report['stream-number']) {
          multipleStreamsFailed = true;
        }

        if (report['packet-loss-ratio-verdict'] === 'fail') {
          packetLossErrorCount++;
        }
        if (report['jitter-verdict'] === 'fail') {
          jitterErrorCount++;
        }
      }
    }

    if (packetLossErrorCount > 0 || jitterErrorCount > 0) {
      if (multipleStreamsFailed) {
        errMsg = 'Multiple test failures occurred. Please review report for more details.';
      } else if (firstFailedStreamNum !== null) {
        errMsg = this.getStreamName(firstFailedStreamNum);
      }

      if (errMsg) {
        const reasons = [];
        if (packetLossErrorCount > 0) reasons.push('packet loss threshold exceeded');
        if (jitterErrorCount > 0) reasons.push('jitter threshold exceeded');
        errMsg += ` failed due to ${reasons.join(', ')}`;
      }
    }

    return errMsg;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getStreamName(streamNum): any {
    if (streamNum === 'Aggregate') return streamNum;
    const uiStream = this.getUIStream(streamNum, true);
    if (uiStream) {
      if (uiStream.name) {
        return uiStream.name;
      } else {
        return uiStream.strmName;
      }
    } else {
      return 'Stream ' + streamNum;
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  convertAngularReportToDisplay(angularReport, displayReport): any {
    if (angularReport != null) {
      const aggregatedData = {
        'engine-a': { bw: 0, ulrOrIr: 0, tx: 0, rx: 0, lost: 0, count: 0 },
        'engine-b': { bw: 0, ulrOrIr: 0, tx: 0, rx: 0, lost: 0, count: 0 }
      };
      for (let x = 0, len = angularReport.length; x < len; ++x) {
        const rpt = angularReport[x];

        if (rpt['originator'] && rpt['stream-number']) {
          const strmIdx = rpt['stream-number'];
          const origIdx = rpt['originator'];

          // add the unique direction data if not already there
          if (!displayReport[origIdx]) {
            displayReport[origIdx] = [];
          }

          const bw = parseFloat(rpt['average-thruput']);
          const ulrOrIr = this.getULROrIR(bw, strmIdx);
          rpt['ulr-or-ir'] = ulrOrIr;
          aggregatedData[origIdx]['bw'] += bw;
          aggregatedData[origIdx]['ulrOrIr'] += ulrOrIr;
          aggregatedData[origIdx]['tx'] += parseInt(rpt['tx-packet-count']);
          aggregatedData[origIdx]['rx'] += parseInt(rpt['rx-packet-count']);
          aggregatedData[origIdx]['lost'] += parseInt(rpt['packet-loss-count']);
          aggregatedData[origIdx]['count']++;

          // compute thr step pakcet loss
          rpt['packet-loss-ratio'] = this.formatFLR(
            rpt['packet-loss-count'] / rpt['tx-packet-count']
          );

          // ms
          rpt['minimum-rtt'] = this.formatKPI(rpt['minimum-rtt'], 3, false); // rtt already in ms from MA
          rpt['average-rtt'] = this.formatKPI(rpt['average-rtt'], 3, false);
          rpt['maximum-rtt'] = this.formatKPI(rpt['maximum-rtt'], 3, false);
          // us
          rpt['minimum-jitter'] = this.formatKPI(rpt['minimum-jitter'], 3, false);
          rpt['average-jitter'] = this.formatKPI(rpt['average-jitter'], 3, false);
          rpt['maximum-jitter'] = this.formatKPI(rpt['maximum-jitter'], 3, false);

          rpt['tx-packet-count'] = this.addCommas(rpt['tx-packet-count']);
          rpt['rx-packet-count'] = this.addCommas(rpt['rx-packet-count']);
          rpt['packet-loss-count'] = this.addCommas(rpt['packet-loss-count']);

          // add the step results to the direction
          displayReport[origIdx].push(rpt);
        }
      }
      for (const origIdx in aggregatedData) {
        if (aggregatedData[origIdx]['count'] > 1) {
          const rpt = {};
          rpt['stream-number'] = 'Aggregate';
          rpt['average-thruput'] = aggregatedData[origIdx]['bw'];
          rpt['ulr-or-ir'] = aggregatedData[origIdx]['ulrOrIr'];
          rpt['packet-loss-ratio'] = this.formatFLR(
            aggregatedData[origIdx]['lost'] / aggregatedData[origIdx]['tx']
          );
          rpt['tx-packet-count'] = this.addCommas(aggregatedData[origIdx]['tx']);
          rpt['rx-packet-count'] = this.addCommas(aggregatedData[origIdx]['rx']);
          rpt['packet-loss-count'] = this.addCommas(aggregatedData[origIdx]['lost']);

          displayReport[origIdx].push(rpt);
        }
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  formatFLR(value: any): string {
    const floatVal = parseFloat(value);
    if (floatVal < 0.0 || floatVal > 1.0) {
      // Suppress negative or out-of-range values.
      return '--';
    }
    return this.convertFLRToPercent(floatVal).toString();
  }

  convertFLRToPercent(value: number): number {
    let floatVal = value * 100;

    if (floatVal > 1.0) {
      floatVal = Math.round(floatVal * 10) / 10; // Round to 1 decimal place.
    } else {
      floatVal = Math.round(floatVal * 1000000) / 1000000; // Round to 6 decimal places.
      if (value > 0.0) {
        floatVal = Math.max(floatVal, 0.000001); // Ensure minimum value.
      }
    }
    floatVal = Math.min(floatVal, 100); // Ensure the value does not exceed 100.
    return floatVal;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  formatKPI(value: any, precision: number, isConvertToMillis: boolean): string {
    if ((!value && value !== 0) || value === '-1.0') {
      return 'N/A';
    }

    let floatVal = parseFloat(value);
    if (isConvertToMillis) {
      floatVal = floatVal / 1000; // Convert from microseconds to milliseconds.
    }

    const multiplier = Math.pow(10, precision);
    floatVal = Math.round(floatVal * multiplier) / multiplier;

    return this.addCommas(floatVal.toFixed(precision));
  }

  addCommas(nStr: string): string {
    nStr += '';
    return nStr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  createOverallTestSetup(): void {
    // Ensure testConfig and nested values are available
    if (
      this.testConfig &&
      this.testConfig['udp:udp'] &&
      this.testConfig['udp:udp']['udp-parameters']
    ) {
      const parms = this.testConfig['udp:udp']['udp-parameters'];

      if (parms['duration']) {
        const displayValue = this.convertSecondsToHMS(parms['duration']);
        this.testConfigDisplay.overall.push({
          name: 'Test Duration (HH:MM:SS)',
          value: displayValue
        });
      } else {
        this.testConfigDisplay.overall.push({
          name: 'Test Duration (HH:MM:SS)',
          value: '00:01:00'
        });
      }

      // Check UI configuration for bandwidth convention and set stream rate convention
      if (
        this.uiConfig &&
        this.uiConfig.pluginConfig &&
        this.uiConfig.pluginConfig.setup &&
        this.uiConfig.pluginConfig.setup.bandwidthConvention
      ) {
        if (this.uiConfig.pluginConfig.setup.bandwidthConvention === 'ir') {
          this.streamRateConvention = this.streamRateConventionL2;
        } else if (this.uiConfig.pluginConfig.setup.bandwidthConvention === 'ulr') {
          this.streamRateConvention = this.streamRateConventionL1;
        }
      }
      if (parms['unit-convention']) {
        this.streamRateConvention =
          parms['unit-convention'] === 'l1-mbps'
            ? this.streamRateConventionL1
            : this.streamRateConventionL2;
      }

      // Add stream rate convention to display data
      this.testConfigDisplay.overall.push({
        name: 'Stream Rate Convention',
        value: this.streamRateConvention
      });
    }
  }

  createStreamsTestSetup(): void {
    if (
      this.testConfig &&
      this.testConfig['udp:udp'] &&
      this.testConfig['udp:udp']['streams'] &&
      this.testConfig['udp:udp']['streams'].length
    ) {
      const numStreams = this.testConfig['udp:udp']['streams'].length;
      const addedDestination = false;
      for (let k = 0; k < numStreams; ++k) {
        const y = k;
        let newStream: any = this.initializeNewStream();

        // Populate the new stream with values based on testConfig
        for (const z in this.testConfig['udp:udp']['streams'][y]) {
          newStream = this.handleStreamAttributes(z, y, k, newStream);
        }

        this.testConfigDisplay.streams.push(newStream);
      }

      this.aggregateData();
    }
  }

  private initializeNewStream(): any {
    return {
      'frame-size': 64,
      udpType: 'Data',
      'jitter-threshold': ''
    };
  }

  private handleStreamAttributes(
    attribute: string,
    streamIndex: number,
    streamCount: number,
    newStream: any
  ): void {
    // **Check the stream-number field from the testConfig object**
    const streamNumber = this.testConfig['udp:udp']['streams'][streamIndex]['stream-number'];

    if (streamNumber >= 11) {
      newStream['originator'] = 'engine-b';
    } else {
      newStream['originator'] = 'engine-a';
    }
    switch (attribute) {
      case 'name':
        // eslint-disable-next-line no-case-declarations
        const name = this.testConfig['udp:udp']['streams'][streamIndex][attribute];
        // eslint-disable-next-line no-case-declarations
        const idx = name.indexOf(':');
        newStream[attribute] = idx > 0 && name.length > idx + 1 ? name.substr(idx + 1) : name;
        break;

      case 'jitter-threshold':
        newStream[attribute] = this.testConfig['udp:udp']['streams'][streamIndex][attribute];
        break;

      case 'bw':
        newStream = this.processBandwidth(
          attribute,
          streamIndex,
          newStream,
          newStream['originator']
        );
        break;

      default:
        newStream = this.processDefaultAttributes(attribute, streamIndex, streamCount, newStream);
        break;
    }

    return newStream;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getUIStream(streamNum: any, streamName?: any): any {
    let mynum;
    // Check if any uiStream has strmNumber equal to streamNum
    const uiStream = this.uiStreams.find(
      stream =>
        stream.strmNumber === parseInt(streamNum) || stream['stream-number'] === parseInt(streamNum)
    );
    if (!streamName && !uiStream) {
      mynum = parseInt(streamNum) - 1;
    }
    if (uiStream) {
      if (streamName) {
        return uiStream;
      }
    } else {
      if (this.uiStreams[mynum]) {
        return this.uiStreams[mynum];
      }
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getStreamConfig(streamNumber, name): any {
    let strmType = null;
    const streamConfig = this.getUIStream(parseInt(streamNumber), true);
    if (streamConfig && typeof streamConfig[name] !== 'undefined') {
      strmType = streamConfig[name];
    } else if (
      this.pluginConfig === false &&
      this.overallConfiguration.config[0] &&
      this.overallConfiguration.config[0].primaryConfig['ietf-lmap-control:lmap'] &&
      this.overallConfiguration.config[0].primaryConfig['ietf-lmap-control:lmap'].schedules &&
      this.overallConfiguration.config[0].primaryConfig['ietf-lmap-control:lmap'].schedules
        .schedule[0] &&
      this.overallConfiguration.config[0].primaryConfig['ietf-lmap-control:lmap'].schedules
        .schedule[0].action[0] &&
      this.overallConfiguration.config[0].primaryConfig['ietf-lmap-control:lmap'].schedules
        .schedule[0].action[0].option[0]
    ) {
      this.bidirsequentialData =
        this.overallConfiguration.config[0].primaryConfig[
          'ietf-lmap-control:lmap'
        ].schedules.schedule[0].action[0].option[0].value;
      this.bidirsequentialData = JSON.parse(this.bidirsequentialData);

      let strmSlaCirVal = null;
      let strmSlaCirValBw2 = null;
      let frameSize = null;

      if (
        (this.streamRateConvention === this.streamRateConventionL1 ||
          this.streamRateConvention === this.streamRateConventionL2) &&
        this.bidirsequentialData['udp:udp'] &&
        this.bidirsequentialData['udp:udp']['streams'][0]
      ) {
        strmSlaCirVal = this.bidirsequentialData['udp:udp']['streams'][0].bw;
        strmSlaCirVal = strmSlaCirVal ? parseFloat(strmSlaCirVal) : null;

        strmSlaCirValBw2 = this.bidirsequentialData['udp:udp']['streams'][0].bw2;
        strmSlaCirValBw2 = strmSlaCirValBw2 ? parseFloat(strmSlaCirValBw2) : null;

        frameSize = this.bidirsequentialData['udp:udp']['streams'][0]['frame-size'];
        frameSize = frameSize ? parseInt(frameSize, 10) : null;
      }
      if (this.streamRateConvention === this.streamRateConventionL1) {
        //ULR Calculation
        this.bidirsequentialUlrOrIrbw =
          strmSlaCirVal && frameSize ? (strmSlaCirVal / (frameSize - 46)) * (frameSize + 20) : null;
        this.bidirsequentialUlrOrIrbw2 =
          strmSlaCirValBw2 && frameSize
            ? (strmSlaCirValBw2 / (frameSize - 46)) * (frameSize + 20)
            : null;
      } else {
        // IR Calculation
        this.bidirsequentialUlrOrIrbw =
          strmSlaCirVal && frameSize ? (strmSlaCirVal * frameSize) / (frameSize - 46) : null;
        this.bidirsequentialUlrOrIrbw2 =
          strmSlaCirValBw2 && frameSize ? (strmSlaCirValBw2 * frameSize) / (frameSize - 46) : null;
      }
      this.bidirsequentialUlrOrIrbw = this.bidirsequentialUlrOrIrbw
        ? this.roundToPrecision(this.bidirsequentialUlrOrIrbw, 2)
        : null;
      this.bidirsequentialUlrOrIrbw2 = this.bidirsequentialUlrOrIrbw2
        ? this.roundToPrecision(this.bidirsequentialUlrOrIrbw2, 2)
        : null;
    }
    return strmType;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  roundToPrecision(number, precision): any {
    if (!number || !precision) {
      return number;
    }
    return (+(Math.round(+(number + 'e' + precision)) + 'e' + -precision)).toFixed(precision);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getStreamType(streamNumber: any): any {
    const type = this.pluginConfig
      ? this.getStreamConfig(streamNumber, 'strmUdpType')
      : this.getStreamConfig(streamNumber, 'stream-type');
    return type ? type : '';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getStreamULROrIR(streamNumber: any): any {
    return this.pluginConfig
      ? this.getStreamConfig(streamNumber, 'strmSlaULROrIR')
      : this.getStreamConfig(streamNumber, 'ir');
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getStreamULROrIR2(streamNumber: any): any {
    return this.getStreamConfig(streamNumber, 'strmSlaULROrIR2');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getStreamFrameSize(streamNum: any): any {
    const probeStream = this.getProbeStream(streamNum);
    if (probeStream) {
      return probeStream['frame-size'];
    } else {
      return 'unknown';
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getProbeStream(streamNum): any {
    streamNum = parseInt(streamNum);
    if (
      this.testConfig &&
      this.testConfig['udp:udp'] &&
      this.testConfig['udp:udp']['streams'] &&
      this.testConfig['udp:udp']['streams'].length
    ) {
      const numStreams = this.testConfig['udp:udp']['streams'].length;

      for (let y = 0; y < numStreams; ++y) {
        if (
          this.testConfig['udp:udp']['streams'][y]['stream-number'] &&
          this.testConfig['udp:udp']['streams'][y]['stream-number'].toString() ===
            streamNum.toString()
        ) {
          return this.testConfig['udp:udp']['streams'][y];
        }
      }
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getULROrIR(bw, streamNumber: any): any {
    const frameSize = parseInt(this.getStreamFrameSize(streamNumber));
    let targetFrameSize = frameSize;
    if (this.streamRateConvention === this.streamRateConventionL1) targetFrameSize += 20;
    const enableVLAN = 0;

    let irOrUlr = (bw * targetFrameSize) / (frameSize - (46 + enableVLAN * 4));
    irOrUlr = Math.round(irOrUlr * 100) / 100; //Round to two decimal places
    return irOrUlr;
  }

  private processBandwidth(
    attribute: string,
    streamIndex: number,
    newStream: any,
    originator: any
  ): void {
    const streamNumber = this.testConfig['udp:udp']['streams'][streamIndex]['stream-number'];
    const bw = parseFloat(this.testConfig['udp:udp']['streams'][streamIndex][attribute]);
    const ulrOrIr = parseFloat(this.getStreamULROrIR(streamNumber));
    const ulrOrIr2 = parseFloat(this.getStreamULROrIR2(streamNumber));
    const mode = this.testConfig['udp:udp']['streams'][streamIndex]['mode'];

    this.aggregateBandwidthData(mode, attribute, bw, ulrOrIr, ulrOrIr2, originator);
    newStream['ulrOrIr'] = ulrOrIr;
    newStream['ulrOrIr2'] = ulrOrIr2;
    newStream['bw'] = bw;
    return newStream;
  }

  private aggregateBandwidthData(
    mode: string,
    attribute: string,
    bw: number,
    ulrOrIr: number,
    ulrOrIr2: number,
    originator: any
  ): void {
    if (mode === 'bidirectional') {
      if (originator === 'engine-a') {
        this.aggregatedData['engine-a-to-engine-b'][attribute] += bw;
        this.aggregatedData['engine-a-to-engine-b']['ulrOrIr'] += ulrOrIr;
        this.aggregatedData['engine-a-to-engine-b']['ulrOrIr2'] += ulrOrIr2;
        this.aggregatedData['engine-a-to-engine-b']['count']++;
      }
      if (originator === 'engine-b') {
        this.aggregatedData['engine-b-to-engine-a'][attribute] += bw;

        this.aggregatedData['engine-b-to-engine-a']['ulrOrIr'] += ulrOrIr;
        this.aggregatedData['engine-b-to-engine-a']['ulrOrIr2'] += ulrOrIr2;
        this.aggregatedData['engine-b-to-engine-a']['count']++;
      }
    } else if (mode === 'bidirsequential') {
      this.streamMode = 'bidirsequential';
      if (originator === 'engine-a') {
        this.aggregatedData['engine-a-to-engine-b'][attribute] += bw;
        this.aggregatedData['engine-a-to-engine-b']['ulrOrIr'] += ulrOrIr;
        this.aggregatedData['engine-a-to-engine-b']['ulrOrIr2'] += ulrOrIr2;
        this.aggregatedData['engine-a-to-engine-b']['count']++;
      }
      if (originator === 'engine-b') {
        this.aggregatedData['engine-b-to-engine-a'][attribute] += bw;

        this.aggregatedData['engine-b-to-engine-a']['ulrOrIr'] += ulrOrIr;
        this.aggregatedData['engine-b-to-engine-a']['ulrOrIr2'] += ulrOrIr2;
        this.aggregatedData['engine-b-to-engine-a']['count']++;
      }
    } else {
      this.aggregatedData[mode][attribute] += bw;
      this.aggregatedData[mode]['ulrOrIr'] += ulrOrIr;
      this.aggregatedData[mode]['ulrOrIr2'] += ulrOrIr2;
      this.aggregatedData[mode]['count']++;
    }
  }

  private processDefaultAttributes(
    attribute: string,
    streamIndex: number,
    streamCount: number,
    newStream: any
  ): void {
    if (
      this.testConfig['udp:udp']['streams'][0]['mode'] === 'bidirsequential' &&
      streamCount === 0
    ) {
      newStream[attribute] = this.testConfig['udp:udp']['streams'][streamIndex][attribute];
      newStream['bw2'] = '';
    } else if (
      this.testConfig['udp:udp']['streams'][0]['mode'] === 'bidirsequential' &&
      streamCount === 1
    ) {
      newStream[attribute] = this.testConfig['udp:udp']['streams'][streamIndex][attribute];
      if (!newStream.bw) {
        newStream['bw'] = '';
      }
    } else {
      newStream[attribute] = this.testConfig['udp:udp']['streams'][streamIndex][attribute];
    }
    return newStream;
  }

  private aggregateData(): void {
    if (
      this.aggregatedData['engine-a-to-engine-b']['count'] > 1 ||
      (this.aggregatedData['engine-b-to-engine-a']['count'] > 1 &&
        this.streamMode !== 'bidirsequential')
    ) {
      let firstEntry = true;
      for (const mode in this.aggregatedData) {
        const data = this.aggregatedData[mode];
        if (data['count'] > 0) {
          const newStream = {
            name: '',
            mode: mode,
            'packet-loss-ratio-threshold': '',
            'jitter-threshold': '',
            'frame-size': ''
          };
          if (firstEntry) {
            firstEntry = false;
            newStream['name'] = 'Aggregate';
          }
          if (this.aggregatedData[mode]['bw'] > 0) {
            newStream['bw'] = this.aggregatedData[mode]['bw'];
            newStream['ulrOrIr'] = this.aggregatedData[mode]['ulrOrIr'];
            newStream['ulrOrIr2'] = this.aggregatedData[mode]['ulrOrIr2'];
          }
          this.testConfigDisplay.streams.push(newStream);
        }
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  convertSecondsToHMS(value: any): string {
    try {
      const nSecs = parseInt(value);
      if (!Number.isNaN(nSecs)) {
        const hours = Math.floor(nSecs / (60 * 60));
        const divisor_for_minutes = nSecs % (60 * 60);
        const minutes = Math.floor(divisor_for_minutes / 60);
        const divisor_for_seconds = divisor_for_minutes % 60;
        const seconds = Math.ceil(divisor_for_seconds);

        // Ensure each unit has two digits
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = seconds.toString().padStart(2, '0');

        this.rtnValue = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
      }
      return this.rtnValue;
    } catch (err) {
      return value;
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  processStartStopDates() {
    function padZero(x) {
      return x < 10 ? '0' + x : x.toString();
    }
    if (this.stopDate && this.startDate) {
      let diffTime = this.stopDate.getTime() - this.startDate.getTime();
      diffTime = diffTime / 1000;

      let minutes = Math.floor(diffTime / 60);
      const seconds = diffTime % 60;
      let hours = 0;
      if (minutes >= 60) {
        hours = Math.floor(minutes / 60);
        minutes = minutes % 60;
      }
      let days = 0;
      if (hours >= 24) {
        days = Math.floor(hours / 24);
        hours = hours % 24;
      }

      this.duration =
        (days ? days + 'd ' : '') +
        (hours ? hours + 'h ' : '') +
        (minutes ? minutes + 'm ' : '') +
        seconds +
        's';
    }
  }

  getAvailableOriginators(): string[] {
    const available: string[] = [];

    if (this.finalReport) {
      for (const originator of this.originators) {
        if (this.finalReport[originator]) {
          const data = this.finalReport[originator];
          if (data && Object.keys(data).length > 0) {
            available.push(originator);
          }
        }
      }

      const engineAData = this.finalReport['engine-a'];
      if (
        engineAData &&
        engineAData.length > 0 &&
        engineAData[0]['ulr-or-ir'] &&
        engineAData[0]['ulr-or-ir'].toString().length > 10
      ) {
        this.updateFontSize('1.2em');
      } else {
        this.updateFontSize('1.4em');
      }
    }

    return available;
  }

  private updateFontSize(fontSize: string): void {
    // const kpiElements = this.el.nativeElement.querySelectorAll('.stats .kpi');
    // kpiElements.forEach((element: HTMLElement) => {
    //   this.renderer.setStyle(element, 'font-size', fontSize);
    // });
  }

  displayAllTrendingCharts(dataType: string): void {
    const originators = this.getAvailableOriginators();
    originators.forEach(originator => {
      this.displayTrendingChart(originator, dataType);
    });
  }

  displayTrendingChart(originator: string, dataType: string): void {
    const chartId = this.getChartId(originator, dataType);

    if (this.charts[chartId]) {
      return;
    }

    const filter = { originator, dataType, chartId };

    if (!this.firstRetrieveDone && !this.trendingInProgress) {
      this.trendingInProgress = true;
      this.getTrendingData(filter);
    } else if (this.firstRetrieveDone) {
      this.filterChart = filter;
      this.buildTrendingChart(filter);
    }

    this.charts[chartId] = true;
  }

  toggleDataType(dataType: string, isChecked: boolean): void {
    if (isChecked) {
      // Add dataType to the selectedDataType array if checked
      if (!this.selectedDataType.includes(dataType)) {
        this.selectedDataType.push(dataType);
      }
    } else {
      // Remove dataType from the selectedDataType array if unchecked
      this.selectedDataType = this.selectedDataType.filter(type => type !== dataType);
    }

    this.cdr.detectChanges();

    // Render charts immediately after updating the selection
    this.renderCharts();
  }

  hideAllTrendingCharts(dataType: string): void {
    for (const originator of this.originators) {
      this.hideTrendingChart(originator, dataType);
    }
  }

  hideTrendingChart(originator: string, dataType: string): void {
    const chartId = this.getChartId(originator, dataType);
    this.setHideTrendingChart(chartId);
  }

  setHideTrendingChart(chartId: string): void {
    this.displayTrendingChartObject[chartId] = false;
  }

  setDisplayTrendingChart(chartId: string): void {
    this.displayTrendingChartObject[chartId] = true;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  canDisplayTrendingChart(originator, dataType): any {
    let status = false;
    const chartId = this.getChartId(originator, dataType);
    if (chartId in this.displayTrendingChartObject)
      status = this.displayTrendingChartObject[chartId];
    return status;
  }

  existsDataType(item: string): boolean {
    const status = this.selectedDataType.indexOf(item) > -1;
    if (status) {
      this.displayAllTrendingCharts(item);
    }
    return status;
  }

  getAvailableDataTypes(): string[] {
    return this.isPcClientView ? this.pcClientDataTypes : this.dataTypes;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getTrendingData(filter: any): void {
    this.trendingMsg = 'Checking sample availability...';

    // if (this.uiComm.isAuthenticated()) {
    const opt = {
      scheduleId: this.scheduleId,
      reportType: 'rt',
      runid: this.runId
    };

    this.collectorApiService
      .getReportCount(opt, this.isPcClientView)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          const errorMsg = this.helperService.getResponseErrorMsg(response);
          this.trendingMsg = 'Retrieving samples'; // Default message

          if (!errorMsg && response.data && response.data.results) {
            this.rptSamplesNeeded = response.data.results;
            this.trendingMsg = `Retrieving ${this.helperService.addCommas(
              this.rptSamplesNeeded.toString()
            )} samples`;
          } else {
            console.error('ERROR: Report Count Failed:', errorMsg);
          }

          this.getReports(filter, this.reportStartTime);
        },
        error => {
          console.error('Error fetching report count:', error);
        }
      );
    // } else {
    //   alert('ERROR: Report cannot be created because UIComm is not connected');
    // }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getReports(filter: string, fromTime?: string): void {
    this.rptRequestCtr++;

    const opt: any = {
      scheduleId: this.scheduleId,
      reportType: 'rt',
      runid: this.runId,
      maxresults: 1000
    };

    if (fromTime) {
      opt.fromtime = fromTime;
    }

    this.collectorApiService
      .getQueryReportByFromTime(
        this.scheduleId,
        this.runId,
        'rt',
        fromTime,
        1000,
        null,
        this.isPcClientView
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          const getRTResultResponse = response.data.filter(data => {
            const instanceStartTime = this.lmapService.getTagValue(
              data['ietf-lmap-report:report'].result[0].tag,
              'instance-start-time'
            );
            return instanceStartTime === this.reportStartTime;
          });
          this.processReportBatch({ data: getRTResultResponse }, filter);
        },
        error => {
          console.error('Error fetching report:', error);
        }
      );
  }

  renderCharts(): void {
    for (const origin of this.getAvailableOriginators()) {
      const engineData = this.trendingResults[origin];
      let timestamps;
      // Chart configurations for each data type
      const chartConfigs = [
        { title: 'Throughput', yAxisTitle: 'Throughput (Mbps)', dataKey: 'thruput' },
        {
          title: 'Packet Loss Ratio',
          yAxisTitle: 'Packet Loss Ratio (%)',
          dataKey: 'packetLossRatio'
        },
        { title: 'Round Trip Time', yAxisTitle: 'RTT (ms)', dataKey: 'rtt' },
        { title: 'Jitter', yAxisTitle: 'Jitter (ms)', dataKey: 'jitter' }
      ];

      chartConfigs.forEach(config => {
        if (this.selectedDataType.includes(config.title)) {
          const chartId = `chart-${origin}-${config.title.replace(' ', '-')}`;
          if (Highcharts.charts[chartId]) {
            Highcharts.charts[chartId].destroy();
          }

          // Prepare series data for all streams
          const seriesData: Highcharts.SeriesOptionsType[] = engineData
            ? Object.keys(engineData)
                .filter(streamKey => {
                  // Skip "Aggregate" for RTT or Jitter
                  return !(
                    streamKey === 'Aggregate' &&
                    (config.title === 'Round Trip Time' || config.title === 'Jitter')
                  );
                })
                .map(streamKey => {
                  const stream = engineData[streamKey];
                  timestamps = stream.statEndTime.map(timestamp => new Date(timestamp).getTime());
                  streamKey === 'Aggregate'
                    ? (config.title = 'Aggregate ' + config.title)
                    : config.title;
                  return {
                    type: 'line',
                    name: streamKey === 'Aggregate' ? 'Aggregate' : `${stream.name}`,
                    data: this.trendingSeries(stream[config.dataKey], timestamps)
                  };
                })
            : [];

          // Prepare chart options
          const options = this.getCommonChartOptions({
            renderTo: chartId,
            title: config.title,
            yAxisTitle: config.yAxisTitle,
            seriesData,
            timestamps,
            unit: config.title === 'Packet Loss Ratio' ? '%' : '',
            dataType: config.title
          });

          // Render the chart
          Highcharts.chart(options);
        }
      });
    }
  }

  // Method to create series data (combining time and stats)
  trendingSeries(dataPoints: number[], timestamps: number[]): [number, number][] {
    return timestamps.map((timestamp, index) => {
      // Convert timestamp to a number for plotting
      return [new Date(timestamp).getTime(), round(dataPoints[index], 3)];
    });
  }

  getUnitForDataType(dataType: string): string {
    switch (dataType) {
      case this.dataTypes[0]:
        return 'Mbps'; // Throughput
      case this.dataTypes[1]:
        return '%'; // Packet Loss Ratio
      case this.dataTypes[2]:
        return 'ms'; // Latency
      case this.dataTypes[3]:
        return 'ms'; // Jitter
      default:
        return ''; // Default if no match
    }
  }

  getCommonChartOptions(config: {
    renderTo: string;
    title: string;
    yAxisTitle: string;
    seriesData: Highcharts.SeriesOptionsType[];
    timestamps: number[];
    dataType?: string;
    unit?: string;
    subtitle?: string;
  }): Highcharts.Options {
    const { renderTo, title, yAxisTitle, seriesData, dataType, timestamps, subtitle } = config;
    const unit = this.getUnitForDataType(dataType);
    return {
      chart: {
        renderTo,
        type: 'line',
        zoomType: 'x'
      },
      title: { text: title },
      subtitle: {
        text: subtitle || '',
        useHTML: true
      },
      xAxis: {
        type: 'datetime', // Set type as datetime for time-based x-axis
        dateTimeLabelFormats: {
          minute: {
            main: '%H:%M'
          },
          hour: {
            main: '%H:%M'
          },
          day: {
            main: '%e. %b'
          },
          week: {
            main: '%e. %b'
          },
          month: {
            main: "%b '%y"
          }
        }
      },
      yAxis: {
        title: { text: yAxisTitle },
        max: unit === '%' ? 100 : undefined,
        alignTicks: unit === '%' ? false : true
      },
      tooltip: {
        shared: true,
        useHTML: true,
        formatter: function () {
          let tooltipContent = '<div class="tooltip-container">';
          this.points.forEach(point => {
            const color = point.color || '#000';
            tooltipContent += `
        <div>
          <span style="color:${color}">●</span>
          <span  class="tooltip-name">${point.series.name}:</span>
          <span class="tooltip-value">${point.y.toFixed(3)}</span>
          ${unit ? `<span class="suffix"> ${unit}</span>` : ''}
        </div>
      `;
          });
          tooltipContent += '</div>';
          return tooltipContent;
        }
      },
      plotOptions: {
        areaspline: {
          lineWidth: 1,
          fillOpacity: 0.2,
          marker: {
            enabled: false,
            states: {
              hover: { enabled: false }
            }
          }
        },
        line: {
          marker: { radius: 2 },
          lineWidth: 2,
          states: { hover: { lineWidth: 1 } },
          threshold: null
        }
      },
      series: seriesData,
      credits: { enabled: false }
    };
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  tooltipFormat(point, unit?: string): any {
    const s = [];
    let tt = '<span style="color:' + point.series.color + '">\u25CF</span>';
    tt += '<span class="tooltip-name">' + point.series.name + ':</span>';
    tt += '<span class="tooltip-value">' + point.y.toFixed(2) + '</span>';
    if (unit) {
      tt += '<span class="suffix"> ' + unit + '</span>';
    }
    s.push(tt);
    return '<div class="tooltip-container">' + s.join('') + '</div>';
  }

  onCheckboxChange(): void {
    this.renderCharts();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  processReportBatch(response: any, filter: any): void {
    const errorMsg = this.helperService.getResponseErrorMsg(response);
    if (!errorMsg) {
      this.chartValid = true;

      if (response.data) {
        let samplesInThisBatch = 0;
        let firstSampleDate = '';
        let lastSampleTag = '';

        if (response.data.length && response.data.length > 0) {
          samplesInThisBatch = response.data.length;
          firstSampleDate = this.lmapService.getReportPostDate(response, 0);
          this.rptLastSampleDate = this.lmapService.getReportPostDate(
            response,
            response.data.length - 1
          );
          lastSampleTag = this.lmapService.getReportTag(response, response.data.length - 1);
        }

        const allRtReport = response.data;

        if (this.rptSamplesReceived !== this.rptSamplesNeeded) {
          this.rptSamplesReceived += samplesInThisBatch;

          for (let i = 0; i < allRtReport.length; i++) {
            const report = this.lmapService.ltranslateLmapReportIndexToAngular(
              allRtReport,
              null,
              i
            );

            if (report !== null && report !== undefined) {
              this.reportArray.push(...report);
            }

            if (report && report.length) {
              let alreadyProcessed = false;

              if (report[0] && report[0][this.lmapService.CONST.resultSequenceId]) {
                alreadyProcessed = this.rptSeqNumsProcessed.includes(
                  report[0][this.lmapService.CONST.resultSequenceId]
                );

                if (alreadyProcessed) {
                  this.rptSamplesReceived--;
                  return;
                }

                this.rptSeqNumsProcessed.push(report[0][this.lmapService.CONST.resultSequenceId]);
              }

              const numberOfStreams = {
                'engine-a': this.getNumberOfStreams('engine-a'),
                'engine-b': this.getNumberOfStreams('engine-b')
              };

              const aggregatedReport: any = {};

              report.forEach((row: any, z: number) => {
                if (
                  row?.status?.includes('TIME_REMAINING_') &&
                  row['packet-loss-count'] &&
                  row['originator'] &&
                  row['stream-number']
                ) {
                  this.rptSampleEndTime = new Date(
                    row[this.lmapService.CONST.resultEndDateId] ||
                      row[this.lmapService.CONST.resultPostDateId]
                  );

                  let streamNumber = row['stream-number'];
                  const originator = row['originator'].replace(/[\s_]+/g, '-').toLowerCase();
                  if (originator === 'engine-b') {
                    const streamNumberValue = parseInt(row['stream-number'], 10);
                    const streamNumberUpdate = streamNumberValue + 10;
                    streamNumber = streamNumberUpdate.toString();
                  }

                  if (!this.trendingResults[originator]) {
                    this.trendingResults[originator] = {};
                  }

                  const thisStream = this.trendingResults[originator][streamNumber] || {
                    name: this.getStreamName(streamNumber),
                    originator: '',
                    statEndTime: [],
                    packetLossRatio: [],
                    currentPacketLossCount: [],
                    rtt: [],
                    jitter: [],
                    thruput: []
                  };

                  this.trendingResults[originator][streamNumber] = thisStream;

                  const statEnd = this.rptSampleEndTime.getTime();

                  if (numberOfStreams[originator] > 1) {
                    this.updateAggregateResult(row, statEnd, aggregatedReport);
                  }

                  this.trendChartData = this.saveTrendData(row, statEnd, thisStream);
                }
              });

              for (const key in aggregatedReport) {
                if (Object.prototype.hasOwnProperty.call(aggregatedReport, key)) {
                  this.setAggregateResult(aggregatedReport);
                  break;
                }
              }
            }
          }

          for (const engine in this.trendingResults) {
            for (const streamNumber in this.trendingResults[engine]) {
              const finalReports = this.finalReport[engine] || [];
              finalReports.forEach((finalReport: any) => {
                if (finalReport['stream-number'] === streamNumber) {
                  const txPacketCount = parseInt(
                    (finalReport['tx-packet-count'] || '0').replace(/,/g, ''),
                    10
                  );

                  if (txPacketCount) {
                    const trendData = this.trendingResults[engine][streamNumber];
                    const packetsPerSample =
                      txPacketCount / trendData.currentPacketLossCount.length;
                    trendData.currentPacketLossCount.forEach((count: number) => {
                      trendData.packetLossRatio.push(
                        Math.round((count / packetsPerSample) * 1000) / 10
                      );
                    });
                  }
                }
              });
            }
          }
        }

        if (response && response.data) {
          response.data.length = 0;
          delete response.data;

          const currentTime = new Date().getTime();
          const elapsedTime = currentTime - this.rptStartRequestTime;
          this.rptTotalTime += elapsedTime;

          if (
            this.rptBatchSize === response.samplesInThisBatch &&
            this.rptSamplesReceived !== this.rptSamplesNeeded
          ) {
            if (this.rptSamplesNeeded > 0) {
              const percentComplete = Math.floor(
                (this.rptSamplesReceived / this.rptSamplesNeeded) * 100
              );
              const samplesNeeded = this.rptSamplesNeeded;
              const samplesReceived = this.rptSamplesReceived;

              this.trendingMsg = `Retrieving ${this.helperService.addCommas(
                this.rptSamplesNeeded.toString()
              )} samples (${percentComplete}%)`;
              this.trendingPercent = percentComplete;
            }

            this.rptRequestRetries = 0; // Reset for new request

            setTimeout(() => this.getReports(filter, this.rptLastSampleDate), this.rptTimeOutMs);
          } else {
            if (this.rptSamplesNeeded > 0) {
              this.trendingMsg = `Retrieving ${this.helperService.addCommas(
                this.rptSamplesNeeded.toString()
              )} samples (100%)`;
            } else {
              this.trendingMsg = 'Retrieving samples complete';
            }

            this.trendingPercent = 100;
            this.trendingComplete = true;

            this.renderCharts();

            this.setDisplayTrendingChart(filter.chartId);
            this.filterChart = filter;
            this.buildTrendingChart(filter);

            this.trendingInProgress = false;
            this.firstRetrieveDone = true;
          }
        } else {
          if (response.data && response.data.code === 408) {
            if (this.rptRequestRetries < this.rptMaxRequestRetries) {
              this.rptRequestRetries++;
              this.rptRequestCtr--;
              setTimeout(() => this.getReports(this.rptLastSampleDate), this.rptTimeOutMs);
            } else {
              alert(
                'Aborting trend chart creation because the request for data timed out repeatedly.'
              );
            }
          } else {
            this.trendingInProgress = false;
          }
        }
      }
    }
  }

  getNumberOfStreams(originator: string): number {
    return originator in this.finalReport ? this.finalReport[originator].length : 0;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setAggregateResult(aggregatedReport: any): void {
    for (const originator in aggregatedReport) {
      let thisStream = null;

      if (!(originator in this.trendingResults)) {
        console.log('Originator is not in trendingResults');
      } else {
        if (this.aggregateDataRptKey in this.trendingResults[originator]) {
          thisStream = this.trendingResults[originator][this.aggregateDataRptKey];
        }
      }

      if (!thisStream) {
        thisStream = {
          name: this.aggregateDataRptKey,
          originator: '',
          statEndTime: [],
          packetLossRatio: [],
          currentPacketLossCount: [],
          rtt: [],
          jitter: [],
          thruput: []
        };
        this.trendingResults[originator][this.aggregateDataRptKey] = thisStream;
      }

      const statEnd = aggregatedReport[originator]['statEndTime'];
      this.saveTrendData(aggregatedReport[originator], statEnd, thisStream);
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  updateAggregateResult(report: any, startEnd: string, aggregatedReport: any): void {
    const originator = report['originator'].replace(/[\s_]+/g, '-').toLowerCase();

    if (!(originator in aggregatedReport)) {
      aggregatedReport[originator] = {
        'current-rtt': '0',
        'current-jitter': '0',
        'current-thruput': 0,
        'tx-packet-count': 0,
        'current-packet-loss-count': 0
      };
    }

    aggregatedReport[originator]['originator'] = originator;
    aggregatedReport[originator]['statEndTime'] = startEnd;
    aggregatedReport[originator]['current-thruput'] += parseFloat(report['current-thruput']);
    aggregatedReport[originator]['tx-packet-count'] += parseInt(report['tx-packet-count'], 10);
    aggregatedReport[originator]['current-packet-loss-count'] += parseInt(
      report['current-packet-loss-count'],
      10
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  saveTrendData(report: any, statEnd: string, thisStream: any): void {
    thisStream.statEndTime.push(statEnd);

    let data = Math.round(parseFloat(report['current-thruput']) * 100) / 100;
    thisStream.thruput.push(data);

    data = report['originator'].toLowerCase();
    thisStream.originator = data;

    thisStream.currentPacketLossCount.push(report['current-packet-loss-count']);

    data = Math.round(parseFloat(report['current-rtt']) * 1000) / 1000;
    thisStream.rtt.push(data);

    data = Math.round(parseFloat(report['current-jitter']) * 1000) / 1000;
    thisStream.jitter.push(data);

    return thisStream;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  buildTrendingChart(filter: any): void {
    this.filterChart = filter;
    const { dataType, originator, chartId } = filter;

    if (!(originator in this.trendingResults)) {
      console.warn('No data for originator:', originator);
      return;
    }

    this.hasAggregate = false;
    const mySeries: any[] = [];

    Object.keys(this.trendingResults[originator]).forEach(key => {
      const labelPrefix = this.trendingResults[originator][key].name;

      if (labelPrefix === this.aggregateDataRptKey) {
        if (dataType === this.dataTypes[2] || dataType === this.dataTypes[3]) {
          return; // Skip for RTT and Jitter
        }
        this.hasAggregate = true;
      }

      const currSeries = { type: 'line', name: '', data: [] };
      const streamData = this.trendingResults[originator][key];

      this.makeTrendingSeries(currSeries, streamData, dataType, labelPrefix);
      mySeries.push(currSeries);
    });

    const unit = this.getUnit(dataType);
    const title = this.hasAggregate ? `Aggregate ${dataType}` : dataType;
    const yAxisLabel = `${dataType} (${unit})`;

    const options: Highcharts.Options = {
      chart: {
        renderTo: chartId,
        zoomType: 'x'
      },
      credits: { enabled: false },
      title: { text: title },
      subtitle: {
        text: 'Click labels in legend to toggle display of series.',
        useHTML: true
      },
      xAxis: { type: 'datetime' },
      yAxis: {
        title: { text: yAxisLabel },
        max: unit === '%' ? 100 : undefined,
        alignTicks: unit === '%' ? false : true
      },
      legend: { enabled: true },
      tooltip: {
        useHTML: true,
        formatter: function () {
          return `<div class="tooltip-container">
            <span style="color:${this.color}">\u25CF</span>
            <span class="tooltip-name">${this.series.name}:</span>
            <span class="tooltip-value">${this.y}</span><span class="suffix"> ${unit}</span><br/>
          </div>`;
        }
      },
      plotOptions: {
        line: {
          marker: { radius: 2 },
          lineWidth: 2,
          states: { hover: { lineWidth: 1 } },
          threshold: null
        }
      },
      series: mySeries
    };

    const chart = Highcharts.chart(options);
    if (chart) {
      this.charts[chartId] = chart;
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  makeTrendingSeries(series: any, streamData: any, dataType: string, labelPrefix: string): void {
    series.name = labelPrefix;
    const dataSeries = this.getDataSeries(streamData, dataType);

    const combinedArray = this.combineTimesAndStats(streamData.statEndTime, dataSeries);
    series.data = JSON.parse(JSON.stringify(combinedArray));
  }

  combineTimesAndStats(timeArray: number[], statArray: number[]): any[] {
    const combinedArray = [];
    if (timeArray?.length === statArray?.length) {
      for (let i = 0; i < timeArray.length; i++) {
        if (statArray[i] !== null) {
          combinedArray.push([timeArray[i], statArray[i]]);
        }
      }
    } else {
      console.warn('Timestamps and stats array lengths do not match.');
    }
    return combinedArray;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getDataSeries(streamData: any, dataType: string): number[] | undefined {
    switch (dataType) {
      case this.dataTypes[0]:
        return streamData.thruput;
      case this.dataTypes[1]:
        return streamData.packetLossRatio;
      case this.dataTypes[2]:
        return streamData.rtt;
      case this.dataTypes[3]:
        return streamData.jitter;
      default:
        return undefined;
    }
  }

  getUnit(dataType: string): string {
    switch (dataType) {
      case this.dataTypes[0]:
        return 'Mbps';
      case this.dataTypes[1]:
        return '%';
      case this.dataTypes[2]:
      case this.dataTypes[3]:
        return 'ms';
      default:
        return '';
    }
  }

  private getChartId(originator: string, dataType: string): string {
    let chartId = `${originator}-${dataType}`;
    chartId = chartId.replace(/[\s_]+/g, '-').toLowerCase();
    return chartId;
  }

  getAgentURLLabel(): string {
    const deviceId = this.overallConfiguration?.agent?.primary?.id;
    const device = this.deviceService.findDeviceByUniqueName(deviceId);
    return this.overallConfiguration &&
      device?.['deviceData']?.['model']?.model === AGENT_MODEL.VTA_TS
      ? 'vTA-TS Test URL'
      : 'vSPA-SAT-TS Test URL';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  orderByStream(stream: any[]): any[] {
    return stream.sort((v1, v2) => {
      v1 = v1['stream-number'];
      v2 = v2['stream-number'];
      return isNaN(v1) ? 1 : isNaN(v2) ? -1 : parseInt(v1, 10) > parseInt(v2, 10) ? 1 : -1;
    });
  }

  ngAfterViewInit(): void {
    this.renderCharts();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
